import { Routes } from '@angular/router';

export const PageRoutingModule: Routes = [];
